import React from 'react';
import { FacebookIcon, InstagramIcon, MailIcon, PhoneIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { CONTACT } from '../data/media';
import { Mascot } from './Mascot';
export function Footer() {
  const {
    t
  } = useLanguage();
  const links = [{
    href: '#services',
    label: t.nav.services
  }, {
    href: '#projects',
    label: t.nav.gallery
  }, {
    href: '#about',
    label: t.nav.about
  }, {
    href: '#process',
    label: t.nav.process
  }, {
    href: '#contact',
    label: t.nav.contact
  }, {
    href: '#contact',
    label: t.footer.privacy
  }];
  return <footer className="w-full bg-ink pt-16 lg:pt-20" data-id="element-116" data-mp="3leviv7odbqit">
      <div className="mx-auto max-w-shell px-4 sm:px-6 lg:px-8" data-id="element-117" data-mp="3lggc8tyy53f3">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4" data-id="element-118" data-mp="3qcdpgrewxtnn">
          <div className="lg:pr-6" data-id="element-119" data-mp="29yxehh44xsnx">
            <div className="flex items-center gap-3" data-id="element-120" data-mp="29xm1qrsppako">
              <Mascot size={48} tone="dark" animate data-id="element-121" data-mp="2eyt8cnj4c3pr" />
              <span className="font-display text-sm font-extrabold uppercase leading-tight text-white" data-id="element-122" data-mp="2ezl0tphf5lbt">
                Pollo Construction
                <span className="block text-[10px] tracking-[0.22em] text-brand-500" data-id="element-123" data-mp="3gaz3z8yymvmq">
                  &amp; Granite Inc.
                </span>
              </span>
            </div>
            <p className="mt-5 text-sm leading-relaxed text-white/60" data-id="element-124" data-mp="3q8n125k1gf82">{t.footer.about}</p>
            <p className="mt-4 text-sm font-semibold leading-relaxed text-white/75" data-id="element-125" data-mp="3qazp90ge3ltk">
              {t.footer.proudly}
            </p>
            <p className="mt-5 font-display text-xs font-bold uppercase tracking-[0.2em] text-gold-500" data-id="element-126" data-mp="34pa1a0t5yjb">
              {CONTACT.tagline}
            </p>
          </div>

          <nav aria-label={t.footer.quickLinks} data-id="element-127" data-mp="ctqogvrpg7v6">
            <h2 className="font-display text-xs font-extrabold uppercase tracking-[0.18em] text-white" data-id="element-128" data-mp="cv1rgtdbtbl8">
              {t.footer.quickLinks}
            </h2>
            <ul className="mt-5 space-y-3" data-id="element-129" data-mp="mrwmh2ae4tur">
              {links.map(link => <li key={`${link.href}-${link.label}`} data-id="element-130" data-mp="mq3i5tn92lpx">
                  <a href={link.href} className="text-sm font-semibold text-white/60 transition-colors duration-200 ease-smooth hover:text-brand-500" data-id="element-131" data-mp="twfohubaxxsf">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </nav>

          <div data-id="element-132" data-mp="18m3s526yh8jb">
            <h2 className="font-display text-xs font-extrabold uppercase tracking-[0.18em] text-white" data-id="element-133" data-mp="1clmabq7e75ig">
              {t.footer.contact}
            </h2>
            <ul className="mt-5 space-y-3 text-sm" data-id="element-134" data-mp="1hje64vb5rbrx">
              <li data-id="element-135" data-mp="1mk1s32kj52fa">
                <a href={`tel:+1${CONTACT.phoneRaw}`} className="inline-flex items-center gap-2 font-semibold text-white/60 transition-colors duration-200 ease-smooth hover:text-brand-500" data-id="element-136" data-mp="1mjimmlc2g6i5">
                  <PhoneIcon className="h-4 w-4 text-brand-500" aria-hidden="true" data-id="element-137" data-mp="3oczspkkjszas" />
                  {CONTACT.phoneDisplay}
                </a>
              </li>
              <li data-id="element-138" data-mp="2ag5eqppkvag4">
                <a href={`mailto:${CONTACT.email}`} className="inline-flex items-center gap-2 font-semibold text-white/60 transition-colors duration-200 ease-smooth hover:text-brand-500" data-id="element-139" data-mp="2agokz95v8aeb">
                  <MailIcon className="h-4 w-4 text-brand-500" aria-hidden="true" data-id="element-140" data-mp="1wnpaxmour8e5" />
                  {CONTACT.email}
                </a>
              </li>
              <li className="font-semibold text-white/60" data-id="element-141" data-mp="2tdg2bd1ukffq">{CONTACT.license}</li>
              <li className="font-semibold text-white/60" data-id="element-142" data-mp="2pdfq7z280gbu">{t.footer.serviceArea}</li>
              {t.contact.hours.map(line => <li key={line} className="font-semibold text-white/60" data-id="element-143" data-mp="2kbgn8qae7lff">
                  {line}
                </li>)}
            </ul>
          </div>

          <div data-id="element-144" data-mp="18z5xksqy45f7">
            <h2 className="font-display text-xs font-extrabold uppercase tracking-[0.18em] text-white" data-id="element-145" data-mp="18zphgf05p3vv">
              {t.footer.follow}
            </h2>
            <div className="mt-5 flex gap-3" data-id="element-146" data-mp="2rvzip2frjlof">
              {[{
              id: 'facebook',
              Icon: FacebookIcon,
              href: 'https://facebook.com'
            }, {
              id: 'instagram',
              Icon: InstagramIcon,
              href: 'https://instagram.com'
            }].map(({
              id,
              Icon,
              href
            }) => <a key={id} href={href} target="_blank" rel="noreferrer" aria-label={id} className="inline-flex h-11 w-11 items-center justify-center rounded border border-white/15 text-brand-500 transition-colors duration-200 ease-smooth hover:border-brand-500 hover:bg-brand-500 hover:text-ink" data-id="element-147" data-mp="2nu5ptgbt7lyt">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-148" data-mp="36jufov0t0c7b" />
                </a>)}
            </div>
            <a href="#contact" className="mt-6 inline-block rounded bg-brand-500 px-5 py-3 font-display text-xs font-extrabold uppercase tracking-wide text-ink transition-colors duration-200 ease-smooth hover:bg-brand-400" data-id="element-149" data-mp="1q5cgeek01s7x">
              {t.nav.quote}
            </a>
          </div>
        </div>

        <div className="mt-14 flex flex-col gap-3 border-t border-white/10 py-7 text-xs font-semibold text-white/45 sm:flex-row sm:items-center sm:justify-between" data-id="element-150" data-mp="1ioz4k8jfig6s">
          <p data-id="element-151" data-mp="1roug4egwcd7c">
            © {new Date().getFullYear()} {CONTACT.company}. {t.footer.rights}
          </p>
          <p className="flex flex-wrap items-center gap-x-4 gap-y-1" data-id="element-152" data-mp="13yi0ehfetc67">
            <span data-id="element-153" data-mp="zx69m8ksukwf">{CONTACT.license}</span>
            <span className="text-brand-500" data-id="element-154" data-mp="zy7v76zfypse">{t.footer.licensed}</span>
          </p>
        </div>
      </div>
    </footer>;
}